import React, {ReactElement, ReactNode} from 'react';
import Paragraph from '../Text/Paragraph/Paragraph';
import CheckpointItem, {Icon, IconColor} from './CheckpointItem';
import {Alignment} from '../../../types';
import {Locale, useLocale} from '../../../RootProvider/LocaleContext';

interface ListItem {
  id: number | string;
  content: string | ReactNode;
  locales?: Locale[];
}

interface Props {
  className?: string;
  icon: Icon;
  iconColor?: IconColor;
  listItems: ListItem[];
}

function CheckpointsContainer({className, icon, iconColor, listItems}: Props): ReactElement {
  const locale = useLocale();
  return (
    <div className={`checkpoints ${className || ''}`.trim()}>
      {listItems
        .filter((entry) => !entry.locales || entry.locales.includes(locale))
        .map(({content, id}) => (
          <CheckpointItem key={id} icon={icon} iconColor={iconColor}>
            <Paragraph alignment={Alignment.LEFT}>{content}</Paragraph>
          </CheckpointItem>
        ))}
    </div>
  );
}

export default CheckpointsContainer;
